module.exports = __webpack_public_path__ + "img/social.02d62ea8.svg";